// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { gql } from '@apollo/client'

import Document from 'js/components/Document'
import FetchMore from 'js/components/FetchMore'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import Section from 'js/components/Section/Section'
import Text from 'js/components/Text/Text'
import { iconViewFragment } from 'js/lib/fragments/icon'
import { userIntroFragment } from 'js/lib/fragments/UserIntro.fragment'
import usePersistedCacheQuery from 'js/lib/hooks/usePersistedCacheQuery'

import Notification from './components/Notification'
import styles from './Notifications.module.css'

const FETCH_COUNT = 25

const Notifications = () => {
    const { t } = useTranslation()

    const PAGE_SIZE = FETCH_COUNT
    const { loading, data, fetchMore } = usePersistedCacheQuery(
        NOTIFICATIONS_QUERY,
        {
            variables: {
                offset: 0,
                limit: PAGE_SIZE,
            },
        },
    )

    return (
        <>
            <Document title={t('notifications.title')} />
            <Section backgroundColor="white" grow>
                <Container>
                    <H1>{t('notifications.title')}</H1>
                    <ul className={styles.wrapper}>
                        {loading ? (
                            <LoadingSpinner
                                style={{
                                    marginTop: '-8px',
                                    marginBottom: '16px',
                                }}
                            />
                        ) : (
                            <FetchMore
                                edges={data.notifications.edges}
                                getMoreResults={(data) =>
                                    data.notifications.edges
                                }
                                fetchMore={fetchMore}
                                fetchType="scroll"
                                fetchCount={FETCH_COUNT}
                                maxLimit={data.notifications.total}
                                noResults={
                                    <Text
                                        size="small"
                                        variant="grey"
                                        className="NotificationsEmpty"
                                    >
                                        {t('notifications.no-notifications')}
                                    </Text>
                                }
                            >
                                <ul>
                                    {data.notifications.edges.map(
                                        (notification, i) => (
                                            <Notification
                                                key={i}
                                                notification={notification}
                                            />
                                        ),
                                    )}
                                </ul>
                            </FetchMore>
                        )}
                    </ul>
                </Container>
            </Section>
        </>
    )
}

export const NOTIFICATIONS_QUERY = gql`
    query NotificationsList($offset: Int, $limit: Int, $unread: Boolean) {
        notifications(offset: $offset, limit: $limit, unread: $unread) {
            total
            edges {
                id
                action
                customMessage
                description
                performer {
                    ...UserIntro
                    username
                }
                entity {
                    guid
                    ... on Blog {
                        title
                        url
                    }
                    ... on News {
                        title
                        url
                    }
                    ... on Discussion {
                        title
                        url
                    }
                    ... on Event {
                        title
                        url
                    }
                    ... on GenericArticle {
                        title
                        url
                    }
                    ... on Question {
                        title
                        url
                    }
                    ... on Task {
                        title
                        url
                    }
                    ... on FileFolder {
                        title
                        url
                    }
                    ... on StatusUpdate {
                        url
                    }
                    ... on Wiki {
                        title
                        url
                    }
                    ... on Comment {
                        title
                        url
                    }
                    ... on ChatMessage {
                        guid
                        chat {
                            guid
                        }
                    }
                }
                container {
                    guid
                    ... on Group {
                        name
                        url
                        ${iconViewFragment}
                    }
                }
                isUnread
                timeCreated
            }
        }
    }
    ${userIntroFragment}
`

export default Notifications
